import React from "react";

const Skills = () => {
  const renderRow = (label, data) => (
    <>
      <div className="text-[6px] md:text-[14px] text-black font-normal leading-tight">
        {label}
      </div>
      {data.map((num, idx) => (
        <div
          key={idx}
          className="h-4 md:h-7 bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center"
        >
          {num}
        </div>
      ))}
    </>
  );

  const skillsData = [
    { label: "No Metric", data: Array(9).fill("345") },
    { label: "Metric", data: ["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"] },
    { label: "Studied Agriculture in School", data: Array(9).fill("345") },
    { label: "Tertiary Qualification", data: ["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"] },
    { label: "Agricultural College", data: Array(9).fill("345") },
    { label: "Post Graduate", data: ["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"] },
    { label: "On-Job Training", data: Array(9).fill("345") },
  ];

  const landData = [
    { label: "Access to Finance", data: Array(9).fill("345") },
    { label: "Regulatory and Compliance Burdens", data: ["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"] },
    { label: "Market Access and Competition", data: Array(9).fill("345") },
    { label: "Skills Gaps", data: ["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"] },
    { label: "Infrastructure and Technology Access", data: Array(9).fill("345") },
    { label: "Cash Flow and Late Payments", data: ["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"] },
    { label: "Limited Mentorship and Support Networks", data: Array(9).fill("345") },
    { label: "Economic and Political Instability", data: Array(9).fill("345") },
    { label: "Lack of Innovation and Differentiation", data: ["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"] },
    { label: "Access to Information and Opportunities", data: Array(9).fill("345") },
    { label: "Crime & Insecurity", data: ["2450", "2179", "2340", "3212", "2345", "3450", "2345", "2245", "3145"] },
    { label: "Others", data: Array(9).fill("345") },
  ];

  const renderSection = (title, data) => (
    <div className="md:mt-8 mt-4">
      <div className="flex md:flex-row items-start gap-1 md:gap-[110px] mb-2">
        <div>
          <p className="text-[#F38323] font-bold text-[6px] md:text-[20px]">{title}</p>
        </div>
      </div>
      <div className="md:h-[2.5px] h-[1px] bg-black/50"></div>
      <div className="overflow-x-auto">
        <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-2 gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">
          {data.map(({ label, data }, idx) => (
            <React.Fragment key={idx}>{renderRow(label, data)}</React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="md:px-24 px-4">
      <div>
        <div className="mb-6 md:mt-6 mt-3">
          <div className="md:mt-14 mt-8">
            <div className="flex md:flex-row items-start gap-1 md:gap-[110px] mb-6">
              <div>
                <p className="text-[#F38323] font-bold text-[6px] md:text-[20px]">
                  SKILLS TRAINING AND QUALIFICATIONS
                </p>
              </div>
            </div>
            <div className="md:h-[2.5px] h-[1px] bg-black/50"></div>
            <div className="overflow-x-auto">
              <div className="md:w-auto grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-2 gap-y-1 gap-x-1 md:gap-x-2 mt-2 md:mt-3">
                {skillsData.map(({ label, data }, idx) => (
                  <React.Fragment key={idx}>{renderRow(label, data)}</React.Fragment>
                ))}
              </div>
            </div>
          </div>
          {renderSection("CHALLENGES AND HURDLES", landData)}
        </div>
      </div>
      <div className="flex justify-end md:mt-14">
    <div>
    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-2 md:px-4">
          <span>SEND</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746037449/Send_hor_fill_lfkysb.png"
            alt="Save Icon"
            className="md:w-[35px] h-3  md:h-[38px] w-3 "
          />
        </button>
        <p className='md:text-[14px]  text-[6px] md:mt-2 mb-3 mt-1 font-normal md:px-1 '>
        Send Due diligence form
        </p>
    </div>
    </div>
    </div>
  );
};

export default Skills;
